import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {execBI} from '../services/bi-events-manager';

export default class ErrorMessage extends React.Component {
  componentDidMount() {
    execBI('ERROR_PAGE_LOADED', {url: window.location.pathname});
  }

  render() {
    const name = (`error-message ${this.props.className || ''}`).trim();
    return (
      <div className={name}>
        <h1 className="error-title">
          <span className="error-message-ico"></span>
          {this.props.is404 ? <span>404 </span> : null}
          <FormattedMessage id="page404.errorTitle"/>
        </h1>
        <p className="error-description"><FormattedHTMLMessage id="page404.errorDescription"/></p>
      </div>
    );
  }
}

ErrorMessage.propTypes = {
  className: PropTypes.string,
  is404: PropTypes.bool
};



// WEBPACK FOOTER //
// ./components/Error-message.js